import React from 'react';
import { BillableLeadsReport } from './reports/ReportComponents';

export default function ReportBillableSupplier() {
  return (
    <div style={{ maxWidth: '1600px' }}>
      <h2 style={{ margin: '0 0 20px' }}>Billable Leads by Supplier</h2>
      <BillableLeadsReport groupBy="supplier" />
    </div>
  );
}
